import { GET_USER_AUTH } from 'redux/actions/types';

const initialState = {};

const userRegisterInfo = (state = initialState, { type, data }) => {
  switch (type) {
    case GET_USER_AUTH:
      return {
        ...state,
        data,
        isLoading: false,
      };

    default:
      return state;
  }
};

export default userRegisterInfo;
